import { QueryClientProvider } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";
import { getQueryClient } from "@/api/query-client";
import { OldVersionDetector } from "@/components/old-version-detector";
import { AuthProvider } from "@/context/auth-context";

export const AppProviders = ({ children }: PropsWithChildren) => {
  return (
    <QueryClientProvider client={getQueryClient()}>
      <OldVersionDetector />
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  );
};
